import React from 'react';
import { getUserWidgets } from '../../../api/widget';
import helper from '../../../utils/helper';
import Loading from '../../Helpers/Loading';
import Backend from '../../Layouts/Backend';
import { dashboardCustomizeConstants } from '../Configure/DashboardCustom/constants';
import AlarmListWidget from './Widgets/AlarmListWidget';
import AvailableGroupsWidget from './Widgets/AvailableGroupsWidget';
import MonitoringPointWidget from './Widgets/MonitoringPointWidget';
import './dashboard-custom.scss';
import { orderBy } from 'lodash';
import MobileToggle from '../../UI/MobileToggle';
import moment from 'moment';

const CustomDashboard = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [widgets, updateWidgets] = React.useState([]);
  const [lastUpdated, setLastUpdate] = React.useState(
    moment().format('MM/DD/yyyy HH:mm:ss'),
  );
  React.useEffect(() => {
    setLoading(true);
    getUserWidgets()
      .then((resp) => updateWidgets(orderBy(resp, ['index'], 'asc')))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, []);
  if (loading) {
    return (
      <Backend>
        <div className="content-inner">
          <Loading />
        </div>
      </Backend>
    );
  }
  if (!widgets.length) {
    return (
      <Backend>
        <div className="content-inner d-flex flex-column">
          <div className="d-flex flex-1">
            <span>
              This is Custom Dashboard page. Please go to{' '}
              <a
                href="/#/configure/configure-custom-dashboard"
                className="footer-link"
              >
                Configure Custom Dashboard
              </a>{' '}
              to create awesome widgets
            </span>
          </div>
          <div
            className="d-flex justify-content-between align-items-end"
            style={{ flexBasis: '100%' }}
          >
            <MobileToggle
              isMobile={props.isMobile}
              setIsMobile={props.setIsMobile}
            />
            {/* <span>
            {t('Last Updated')}: {props.lastUpdated}
          </span> */}
          </div>
        </div>
      </Backend>
    );
  }
  return (
    <Backend>
      <div className="content-inner">
        <div className="dashboard-custom-section">
          {widgets.map((widget) => {
            return (
              <React.Fragment key={widget.id}>
                {widget.terminateRow ? <hr className="--break-line" /> : null}
                {{
                  [dashboardCustomizeConstants.widget2]: (
                    <AvailableGroupsWidget {...widget} key={widget.id} />
                  ),
                  [dashboardCustomizeConstants.widget4]: (
                    <MonitoringPointWidget {...widget} key={widget.id} />
                  ),
                }[widget.widgetTypeName] || (
                  <AlarmListWidget {...widget} key={widget.id} />
                )}
              </React.Fragment>
            );
          })}
          <div
            className="d-flex justify-content-between align-items-end"
            style={{ flexBasis: '100%' }}
          >
            <MobileToggle
              isMobile={props.isMobile}
              setIsMobile={props.setIsMobile}
            />
            {/* <span>
            {t('Last Updated')}: {props.lastUpdated}
          </span> */}
          </div>
        </div>
      </div>
    </Backend>
  );
};

export default CustomDashboard;
